/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { AxiosPromise } from 'axios';
import { Tenant } from 'types/clients';
import { RequestOptions } from 'api/IamApi/lib/getRequestOptions';
import { CALL_API } from '../middleware/api';
import iamApi from '../api/IamApi';

export const GET_TENANTS_REQUEST = 'GET_TENANTS_REQUEST';
export const GET_TENANTS_SUCCESS = 'GET_TENANTS_SUCCESS';
export const GET_TENANTS_FAILURE = 'GET_TENANTS_FAILURE';

/**
 * Action used to get all tenants
 * @param {*} options should be an object of options
 * @param {*} callback function to run if action is successful
 * @param {*} errorCallback function to run if action fails
 */

export const getTenants = (options: RequestOptions, callback: () => any, errorCallback: () => any): object => ({
  [CALL_API]: {
    types: [
      GET_TENANTS_REQUEST,
      GET_TENANTS_SUCCESS,
      GET_TENANTS_FAILURE,
    ],
    request: (): AxiosPromise => iamApi.clients.readAll(options),
    callback,
    errorCallback,
  },
});

export const loadTenants = (
  options: RequestOptions,
  callback = () => {},
  errorCallback = () => {},
) => (dispatch: (arg0: object) => void) => dispatch(getTenants(options, callback, errorCallback));

// Get selected tenant
export const GET_TENANT_REQUEST = 'GET_TENANT_REQUEST';
export const GET_TENANT_SUCCESS = 'GET_TENANT_SUCCESS';
export const GET_TENANT_FAILURE = 'GET_TENANT_FAILURE';

export const getTenant = (tenantId: string, callback: () => any, errorCallback: () => any): Tenant => ({
  [CALL_API]: {
    types: [
      GET_TENANT_REQUEST,
      GET_TENANT_SUCCESS,
      GET_TENANT_FAILURE,
    ],
    request: (): AxiosPromise => iamApi.clients.read(tenantId),
    callback,
    errorCallback,
  },
});

export const loadTenant = (tenantId: string, callback = () => {},
  errorCallback = () => {}) => (dispatch: (arg0: object) => void) => dispatch(
  getTenant(tenantId, callback, errorCallback),
);
